import { ListCarLicensees } from '~/features/common/Organization/CarLicensees/ListCarLicensees'
import { Container } from '~/shared/ui/Layout'

export function ListCarLicenseePage() {
  return (
    <Container>
      <ListCarLicensees />
    </Container>
  )
}
